module.exports = __webpack_public_path__ + "media/3400_CT_2022_Credential-Harvesting_Attack.cf8ac559.mp4";